<template>
  <div>
    <span @click="OpenDialog">
      <span class="userinfo" type="info">平台权益</span>
    </span>

    <el-dialog title="平台权益" :visible.sync="dialogVisible" width="80%" append-to-body @close="closeUserinfo">
      <el-row>
        <el-col :span="24">
          <div>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>基本信息</span>
              </div>
              <div>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>校区名称</span>

                          <el-tooltip content="校区名称会显示在网页顶部" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div class="info">
                          <span>{{ schoolInfo.name }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>唯一域名</span>

                          <el-tooltip content="通过校区唯一域名访问,个性化展示校区首页。" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div style="text-align: center; height: 55px">
                          <el-link style="line-height: 55px" type="primary">https://{{ schoolInfo.domain }}.steam.fun</el-link>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>到期时间</span>

                          <el-tooltip content="到期后将不能登录系统" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div style="text-align: center; height: 55px">
                          <span style="line-height: 55px">{{
                            schoolInfo.off_time
                          }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <div>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>账号权益</span>
              </div>
              <div>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>分校数</span>

                          <el-tooltip content="当前分校数/可开通的总分校数" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div class="info">
                          <span>{{ campusNum }}</span><span>/</span>
                          <span>{{ schoolInfo.max_campus_num }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>教师数</span>

                          <el-tooltip content="当前教师数/可开通的总教师数" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div class="info">
                          <span>{{ $store.state.user.eduTchList.length }}</span><span>/</span>
                          <span>{{ schoolInfo.max_teacher_num }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>在读学员数</span>

                          <el-tooltip content="当前在读学员数" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div class="info">
                          <span>{{ schoolStuNum }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>

                  <el-col :span="6">
                    <div class="wrapper">
                      <el-card shadow="never">
                        <div slot="header" class="title">
                          <span>剩余时长</span>

                          <el-tooltip content="校区剩余的学生时长数（单位:天）" placement="top">
                            <i style="float: right" class="el-icon-question"></i>
                          </el-tooltip>
                        </div>

                        <div class="info">
                          <span>{{ schoolInfo.stu_remain_time }}</span>

                          <span style="
                                                                    font-size: 14px;
                                                                    margin-left: 10px;
                                                                    cursor: pointer;
                                                                    color: #e6a23c;
                                                                  " @click="TimeRecordList">明细<i class="el-icon-s-data"></i></span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="wrapper1">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>课程权益</span>
              </div>

              <div>
                <el-table size="mini" stripe style="width: 100%" :data="schoolSubjectList">
                  <el-table-column prop="subjectInfo.name" label="科目" width="180">
                  </el-table-column>

                  <el-table-column prop="created_time" label="开通日期" width="180">
                  </el-table-column>
                  <el-table-column prop="off_time" label="截止日期">
                  </el-table-column>

                  <el-table-column align="center" width="150" prop="name" label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="LookCourse(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <!-- 合同 -->
      <el-row>
        <el-col :span="24">
          <div class="wrapper1">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>校区合同</span>
              </div>

              <div>
                <el-table size="mini" stripe style="width: 100%" :data="contactList">
                  <el-table-column prop="title" label="合同名称" width="180">
                  </el-table-column>

                  <el-table-column prop="start_date" label="签约日期" width="180">
                  </el-table-column>
                  <el-table-column prop="end_date" label="截止日期">
                  </el-table-column>

                  <el-table-column align="center" width="150" prop="name" label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="LookContact(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pagination-style">
                  <el-pagination @current-change="handleCurrentChange1" :current-page.sync="page_no1" :page-size="page_size1" layout="total, prev, pager, next" :total="total1"></el-pagination>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :title="subject_title" :visible.sync="dialogVisible1" width="80%" append-to-body>
      <el-table :data="CourseList" border :header-cell-style="{ background: '#f5f7fa' }" size="mini">
        <el-table-column width="100" align="center" label="序号">
          <template slot-scope="scope"> {{ scope.$index + 1 }} </template>
        </el-table-column>

        <el-table-column align="center" width="100" prop="id" label="缩略图">
          <template slot-scope="scope">
            <el-image style="width: 60px; height: 45px" :src="scope.row.img_url" fit="cover"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="title" label="体系名称"></el-table-column>

        <el-table-column align="center" prop="curriculum_desc" label="简介"></el-table-column>

        <el-table-column align="center" prop="number_of_courses" label="讲次数量"></el-table-column>

        <el-table-column align="center" prop="curriculumAuth.created_time" label="开通时间" width="150"></el-table-column>

        <el-table-column align="center" prop="curriculumAuth.off_time" label="到期时间" width="150"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="使用明细" :visible.sync="dialogVisible2" append-to-body width="80%">
      <el-form :inline="true" ref="form1" @submit.native.prevent size="mini">
        <el-form-item>
          <el-input placeholder="请输入真实姓名" @keyup.enter.native="searchStu" v-model="stuName" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属校区">
          <el-select @change="searchStu" v-model="campusIdArr" multiple collapse-tags placeholder="请选择" style="width:220px">
            <el-option v-for="item in options" :key="item.dept_id" :label="item.campusName" :value="item.dept_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人">
          <el-select v-model="operator" placeholder="请选择" clearable>
            <el-option v-for="item in opreatorList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchStu">查询</el-button>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button type="primary" plain @click="handleExportData">导出数据</el-button>
        </el-form-item>
      </el-form>
      <el-table size="mini" :data="stuTimeRecordList" height="500px" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column label="学员姓名" width="200">
          <template slot-scope="scope">
            <span>
              {{ scope.row.stuName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="eduCampusName" label="所属校区"></el-table-column>

        <el-table-column property="num" label="时长变动(天)">
          <template slot-scope="scope">
            <!-- <span style="color: green" v-if="scope.row.num < 0">+{{ -scope.row.num }}</span>
            <span style="color: red" v-else>-{{ scope.row.num }}</span> -->
            <span :style="{color:(Number(scope.row.num)>0)?'green':'red'}">{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column property="realname" label="操作人">
          <template slot-scope="scope">
            <span style="display: inline-block;min-width:40px;text-align: center">
              {{ scope.row.userName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
        <el-table-column property="createdTime" label="操作日期"></el-table-column>
      </el-table>

      <div style="margin-top: 20px; text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page="page_no" :page-size="20" layout="total,prev, pager, next" :total="total"></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="合同" :visible.sync="dialogVisible3" append-to-body width="80%">
      <div class="container">
        <el-row :gutter="15">
          <el-col :span="24">
            <div class="course-left">
              <div class="course-left-ppt">
                <iframe class="course-view" allowfullscreen="true" :src="lession_plan_url"></iframe>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deleteImages } from '@/api/homeset'
import uploadFile from '@/config/uploadFile'
import PreviewFile from '@/config/preview-oss'
import { downLoadFileExcelHandle } from '@/utils/exportExcel'

import {
  tchUpdateTchInfo,
  stuUpdateStudentInfo,
  getSchoolRightInfo,
  getPrepareCurrculumList,
  tchGetContract,
  getUserCampusList,
} from '@/api/educational'
import {
  api_stuTimeRecordSelectDetail,
  api_tchSelectByEduId
} from '@/api/javaApi'

export default {
  name: 'schoolinfo',
  props: {
    homepageBanner: Array,
    homepage_id: Number,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }
    return {
      operator: '', // 操作人
      opreatorList: [],
      campusIdArr: [],
      options: [],
      optionIds: [],
      stuName: '',
      lession_plan_url: '',
      dialogVisible3: false,
      page_no1: 1,
      page_size1: 20,
      total1: 0,
      contactList: [],
      imageId: '',
      search: '',
      form: {
        realname: '',
        nickname: '',
        name: '',
        fileList: [],
        fileList1: [],
      },
      tableData: [
        {
          subject: 'Jrcode',
          title: 'Jrcode编程启蒙L1-L2',
          start_date: '2016-05-04',
          end_date: '2017-05-04',
        },
        {
          subject: 'Scratch',
          title: 'Scratch航天主题',
          start_date: '2017-05-04',
          end_date: '2018-05-04',
        },
        {
          subject: 'Python',
          title: 'Python海龟绘图',
          start_date: '2018-05-04',
          end_date: '2019-05-04',
        },
      ],
      dialogVisible: false,
      dialogVisible1: false,
      rules: {
        title_one: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 4, max: 8, message: '长度在 4 到 8 个字符', trigger: 'blur' },
        ],
        title_two: [{ required: true, message: '请输入口号', trigger: 'blur' }],
        content: [
          { required: true, message: '请填写内容介绍', trigger: 'blur' },
        ],
        fileList: [{ validator: validatePass, trigger: 'change' }],
      },
      uploadFileTime: false,

      //校区权益
      schoolStuNum: 0,
      schoolTchNum: 0,
      campusNum: 0,
      schoolInfo: {
        max_campus_num: 0,
        max_student_num: 0,
        max_teacher_num: 0,
        off_time: '',
        name: '',
        domain: '',
      },

      schoolSubjectList: [], //课程权益
      subject_title: '', //科目名称
      CourseList: [], //课程列表

      //时长使用详情
      dialogVisible2: false,
      stuTimeRecordList: [],
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },
  watch: {
    homepageBanner() {
      this.tableData = this.homepageBanner
    },
  },
  mounted() {
    this.getUserCampusList()
  },
  methods: {
    getUserCampusList() {
      this.optionIds = [];
      getUserCampusList({}).then((res) => {
        console.log(res, 152121)
        // this.form.campusIdArr = [];
        this.options = res.userDeptList
        this.options.forEach(item => {
          this.optionIds.push(item.dept_id)
        })
        // res.userDeptList.map((item) => {
        //   this.form.campusIdArr.push(item.dept_id);
        // });
      })
    },
    //查看合同详情
    LookContact(row) {
      var _that = this
      PreviewFile(row.file_url, function (res) {
        console.log('校区教案预览地址-watch')
        console.log(res)
        _that.lession_plan_url = res
      })
      this.dialogVisible3 = true
    },
    //校区合同
    tchGetContract() {
      tchGetContract({
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        this.contactList = res.contactList
        this.total1 = res.total
      })
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.tchGetContract()
    },
    //获取校区权益信息
    getSchoolRightInfo() {
      getSchoolRightInfo().then((res) => {
        console.log('校区权益数据')
        console.log(res)
        this.campusNum = res.campusNum
        this.schoolInfo = res.schoolInfo
        this.schoolStuNum = res.schoolStuNum
        this.schoolTchNum = res.schoolTchNum
        this.schoolSubjectList = res.schoolSubjectList
      })
    },
    getOperatorList() {
      api_tchSelectByEduId().then(res => {
        console.log('api_tchSelectByEduId:', res)
        this.opreatorList = res;
      })
    },
    addImage() {
      this.form.title_one = ''
      this.form.title_two = ''
      this.form.fileList = []
      this.form.content = ''
      this.imageId = ''
      this.dialogVisible = true
    },

    OpenDialog() {
      console.log('打开校区权益信息')

      this.getSchoolRightInfo()
      this.tchGetContract()

      this.$store.dispatch('tchSelectTchListByEdu')
      this.dialogVisible = true
    },

    closeUserinfo() {
      console.log('关闭用户信息')
      this.dialogVisible = false
    },

    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateImages(row) {
      this.imageId = row.id
      this.form.title_one = row.title_one
      this.form.title_two = row.title_two
      this.form.content = row.content
      this.form.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
      this.dialogVisible = true
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$store.state.user.identity === 2) {
            console.log('更新学生账号信息')

            stuUpdateStudentInfo({
              nickname: this.form.nickname,
              headimg_url: this.form.fileList[0].url,
            }).then(() => {
              this.$message.success('保存成功,重新登陆后生效!')
              this.dialogVisible = false
            })
          } else {
            console.log('更新老师账号信息')
            tchUpdateTchInfo({
              nickname: this.form.nickname,
              headimg_url: this.form.fileList[0].url,
              card_img_url: this.form.fileList1[0].url,
            }).then(() => {
              this.$message.success('保存成功,重新登陆后生效!')
              this.dialogVisible = false
            })
          }
        }
      })
    },
    uploadFile() { },
    handleRemove(file, fileList) {
      this.form.fileList = fileList
    },

    handleRemove1(file, fileList) {
      this.form.fileList1 = fileList
    },

    handleExceed() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },
    handleExceed1() {
      this.$message.warning(`只能上传1张图片，请删除后重新上传！`)
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },

    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileList)
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res
          this.uploadFileTime = false
        }
      )
    },

    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList1 = res
          this.uploadFileTime = false
        }
      )
    },

    deleteImage(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteImages({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')

            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === row.id) {
                this.tableData.splice(i, 1)
              }
            }
          }
        })
      })
    },

    LookCourse(row) {
      console.log('查看科目的课程详情')
      console.log(row)
      this.subject_title = '科目名称:' + row.subjectInfo.name

      this.dialogVisible1 = true
      getPrepareCurrculumList({
        subject_id: row.subject_id,
        teaching_type: '',
        course_type: '',
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        console.log('获得科目课程')
        console.log(res)
        this.CourseList = res.curriculumList
      })
    },

    TimeRecordList() {
      console.log('查看学生时长使用情况')
      this.dialogVisible2 = true
      this.operator = '';
      this.getStuTimeRecordSelectDetail()
      this.getOperatorList()
    },

    //获得时长使用详情
    getStuTimeRecordSelectDetail() {
      api_stuTimeRecordSelectDetail({
        eduCampusIdList: this.campusIdArr.length > 0 ? this.campusIdArr : this.optionIds,
        stuName: this.stuName,
        userId: this.operator,
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size,
        },
      }).then((res) => {
        console.log('时长使用详情')
        console.log(res)
        this.stuTimeRecordList = res.content
        this.total = res.totalSize
      })
    },
    searchStu() {
      this.page_no = 1
      this.getStuTimeRecordSelectDetail()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getStuTimeRecordSelectDetail()
    },
    handleExportData() {
      const params = {
        eduCampusIdList: this.campusIdArr.length > 0 ? this.campusIdArr : this.optionIds,
        stuName: this.stuName,
        userId: this.operator,
      }
      downLoadFileExcelHandle('/java-api/school/stuTimeRecord/exportDetail', params, '平台权益使用明细')
    }
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  .title {
    font-size: 14px;
    color: #353535;
  }

  .info {
    text-align: center;
    font-size: 36px;
    font-weight: 500;
  }
}

.wrapper1 {
  margin-top: 20px;
}

.container {
  background: #f7f8fa;

  .course-left {
    height: calc(100vh - 121px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-left-ppt {
      flex: 6;
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;

      .course-view {
        width: 100%;
        height: 100%;
      }
    }

    .course-left-comment {
      flex: 1;

      display: flex;
      flex-flow: column;

      .course-left-comment-title {
        padding: 10px;
        flex: 1;
        font-weight: 500;
      }

      .course-left-comment-content {
        flex: 1;
      }
    }
  }

  .course-right {
    height: calc(100vh - 121px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-right-video {
      flex: 1;

      .course-right-video-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video-desc {
        .coursevideo {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }

    .course-right-video1 {
      flex: 2;

      .course-right-video1-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video1-wrapper {
        height: calc((100vh - 81px) / 2 + 50px);
        overflow-y: scroll;
      }

      .videolist {
        border-bottom: 1px solid rgb(199, 199, 198);
        padding-bottom: 10px;
      }

      .course-right-video1-desc {
        .coursevideo1 {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }
  }
}
</style>
